import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <div className="footer-container">
            <h4>Made By <a className="footer-text" href="/" target="_blank" rel="noopener noreferrer">Aatif Rashid</a></h4>
        </div>
    )
}

export default Footer
